/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_TaglineInputs */

const en_svc_retainer_tagline = /** @type {(inputs: Svc_Retainer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A monthly engineer on call for your product and workflows.`)
};

const ar_svc_retainer_tagline = /** @type {(inputs: Svc_Retainer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مهندس شهري تحت الطلب لمنتجك وسير عملك.`)
};

const bn_svc_retainer_tagline = /** @type {(inputs: Svc_Retainer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার প্রোডাক্ট ও ওয়ার্কফ্লোর জন্য মাসিক কল ইঞ্জিনিয়ার।`)
};

const de_svc_retainer_tagline = /** @type {(inputs: Svc_Retainer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein monatlicher Ingenieur auf Abruf für Ihr Produkt und Ihre Workflows.`)
};

const es_svc_retainer_tagline = /** @type {(inputs: Svc_Retainer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un ingeniero mensual de guardia para su producto y sus flujos.`)
};

const fr_svc_retainer_tagline = /** @type {(inputs: Svc_Retainer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un ingénieur mensuel d'astreinte pour votre produit et vos flux.`)
};

const pt_svc_retainer_tagline = /** @type {(inputs: Svc_Retainer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um engenheiro mensal de plantão para o seu produto e fluxos.`)
};

const zh_svc_retainer_tagline = /** @type {(inputs: Svc_Retainer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的产品和工作流的按月随叫随到工程师。`)
};

const tr_svc_retainer_tagline = /** @type {(inputs: Svc_Retainer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürününüz ve akışlarınız için aylık nöbetçi mühendis.`)
};

const ru_svc_retainer_tagline = /** @type {(inputs: Svc_Retainer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячный инженер на связи для вашего продукта и флоу.`)
};

const pl_svc_retainer_tagline = /** @type {(inputs: Svc_Retainer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miesięczny inżynier na wezwanie dla produktu i przepływów.`)
};

/**
* | output |
* | --- |
* | "A monthly engineer on call for your product and workflows." |
*
* @param {Svc_Retainer_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_retainer_tagline = /** @type {((inputs?: Svc_Retainer_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_tagline(inputs)
	if (locale === "bn") return bn_svc_retainer_tagline(inputs)
	if (locale === "de") return de_svc_retainer_tagline(inputs)
	if (locale === "es") return es_svc_retainer_tagline(inputs)
	if (locale === "fr") return fr_svc_retainer_tagline(inputs)
	if (locale === "pt") return pt_svc_retainer_tagline(inputs)
	if (locale === "zh") return zh_svc_retainer_tagline(inputs)
	if (locale === "tr") return tr_svc_retainer_tagline(inputs)
	if (locale === "ru") return ru_svc_retainer_tagline(inputs)
	if (locale === "pl") return pl_svc_retainer_tagline(inputs)
	return en_svc_retainer_tagline(inputs)
});